export default __webpack_public_path__ + "static/logo-b17562f357cfffdcf0a8ee22c83c3eec.png";